import { useEffect, useState } from 'react';

import { MedicalImageRender } from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import { EMPTY_MASK_EDIT_STATE, MaskEditState } from '../config';

type UseMaskEditStateParams = {
  isEditingMask: boolean;
};

export const useMaskEditState = (
  params: UseMaskEditStateParams,
): MaskEditState => {
  const { isEditingMask } = params;

  const [maskEditState, setMaskEditState] = useState<MaskEditState>(
    EMPTY_MASK_EDIT_STATE,
  );

  useEffect(() => {
    if (!isEditingMask) {
      setMaskEditState(EMPTY_MASK_EDIT_STATE);
      return;
    }

    // The tool activates before this mounts, so the first state has to be read
    // rather than awaited: the next event only arrives once the user acts.
    setMaskEditState(
      MedicalImageRender.getMaskEditState() ?? EMPTY_MASK_EDIT_STATE,
    );

    const removeListener = MedicalImageRender.addEventListener(
      'maskEditStateChanged',
      ({ canReset, hasPendingChanges, isMaskSelected }) => {
        setMaskEditState({ canReset, hasPendingChanges, isMaskSelected });
      },
    );

    return () => {
      removeListener?.();
    };
  }, [isEditingMask]);

  return maskEditState;
};
